document.addEventListener("DOMContentLoaded", () => {
  //popup OPEN FUNCTION
  var elements = document.querySelectorAll(
    ".image-container.bundle__slide_main_con"
  );
  elements.forEach(function (element) {
    if (!element.hasAttribute("data-clicked")) {
      element.addEventListener("click", onClickHandler);
      element.setAttribute("data-clicked", "true");
    }
  });

  function onClickHandler(event) {
    if (event.target.classList.contains("sldier_opener")) {
      var main_parent_wraper = this.parentNode;
      var overlay_wraper = main_parent_wraper.querySelector(".overlay");
      overlay_wraper.style.display = "block";
      var apply_swiper = this.querySelector(".swiper__custom");
      var apply_swiper_thumbs = this.querySelector(".swiper_thumbs");
      // slect the slider per view for swiper
      if (apply_swiper.classList.contains("slide_per_view_8")) {
        var swiperThumbsOptions = {
          loop: true,
          spaceBetween: 11,
          slidesPerView: 8,
          slideToClickedSlide: true,
        };
      }
      if (apply_swiper.classList.contains("slide_per_view_7")) {
        var swiperThumbsOptions = {
          loop: true,
          spaceBetween: 11,
          slidesPerView: 7,
          slideToClickedSlide: true,
        };
      }
       if (apply_swiper.classList.contains("slide_per_view_6")) {
        var swiperThumbsOptions = {
          loop: true,
          spaceBetween: 11,
          slidesPerView: 6,
          slideToClickedSlide: true,
        };
      }
      if (apply_swiper.classList.contains("slide_per_view_12")) {
        var swiperThumbsOptions = {
          loop: true,
          spaceBetween: 11,
          slidesPerView: 12,
          slideToClickedSlide: true,
        };
      }
      if (apply_swiper.classList.contains("slide_per_view_11")) {
        var swiperThumbsOptions = {
          loop: true,
          spaceBetween: 11,
          slidesPerView: 11,
          slideToClickedSlide: true,
        };
      }
      if (apply_swiper.classList.contains("slide_per_view_13")) {
        var swiperThumbsOptions = {
          loop: true,
          spaceBetween: 11,
          slidesPerView: 13,
          slideToClickedSlide: true,
        };
      }
      thumbsSlider = new Swiper(apply_swiper_thumbs, swiperThumbsOptions);
      var sliderOptions = {
        loop: true,
        spaceBetween: 11,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        thumbs: {
          swiper: thumbsSlider,
        },
      };
      slider = new Swiper(apply_swiper, sliderOptions);
      try {
        var selected_popup = this.querySelector(".popup");
        var selected_popup_overlay_parent = this.parentNode;
        var selected_popup_overlay =
          selected_popup_overlay_parent.previousSibling;
        selected_popup.style.display = "block";
        selected_popup_overlay.style.display = "block";
      } catch (error) {}
    }
  }
  // close the popup slide
  var close_elment = document.querySelectorAll(
    ".bundle__slide_main_con .popup .close"
  );
  function onCloseclick(event) {
    // select element to destroy swiper
    var parentElement = this.parentNode;
    var parentElement_1 = parentElement.parentNode;
    var destroy_swiper = parentElement.querySelector(".swiper__custom");
    var destroy_swiper_thumbs = parentElement.querySelector(".swiper_thumbs");
    // destroy swiper instance
    if (
      typeof destroy_swiper !== "undefined" &&
      destroy_swiper !== null &&
      destroy_swiper instanceof Swiper
    ) {
      destroy_swiper.destroy(true, true);
    }
    if (
      typeof destroy_swiper_thumbs !== "undefined" &&
      destroy_swiper_thumbs !== null &&
      destroy_swiper_thumbs instanceof Swiper
    ) {
      destroy_swiper_thumbs.destroy(true, true);
    }
    // close proslider popup
    var selected_popup_overlay_hide = parentElement_1.parentNode;
    setTimeout(function () {
      selected_popup_overlay_hide.querySelector(".overlay").style.display =
        "none";
      parentElement.style.display = "none";
    }, 100);
  }
  close_elment.forEach(function (element) {
    element.addEventListener("click", onCloseclick);
  });
});




$(document).ready(function() {
    $(".selects").select2();
});
 window.addEventListener('load', function() {
 var border_option = document.querySelector('.bordered_option').getAttribute('value');
  console.log(border_option);
  document.querySelectorAll('.select2-results__option').forEach(function(elem){
    console.log(elem);
  })
})


var searchField = document.getElementsByClassName('select2-search__field') // Assuming you're targeting the first element

// Set the placeholder for the input element
    searchField.placeholder = 'Your Placeholder Text Here';






